import { FormSelectDataProps, FormSelectOption } from './FormSelect.types';

export const DEFAULT_DATA_PROPS: FormSelectDataProps<FormSelectOption> = {
  label: 'label',
  value: 'value',
};
